/**
 * Hook to fetch workspaces where user has can_view_analytics permission
 *
 * This hook is specifically for the metrics page to show only workspaces
 * where the user has permission to view analytics.
 */

import { useState, useEffect } from 'react';
import { getUserWorkspaces } from '../../../../../services/workspaceService';
import { Workspace } from '../../../../../types/workspace';

export const useWorkspacesWithAnalytics = () => {
  const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await getUserWorkspaces(0, 100, 'can_view_analytics');
        setWorkspaces(response.data);
      } catch (err) {
        console.error('Failed to fetch workspaces with analytics permission:', err);
        setError('Erro ao carregar workspaces');
        setWorkspaces([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWorkspaces();
  }, []);

  return {
    workspaces,
    isLoading,
    error,
  };
};
